<template>
  <AVNormalSummary
    :sorted-result="result.resultDataForDisplay"
    :total-count="totalCount"
    :hide-percentage="!contest.resultPercentages"
    :hide-tied="!votingRoundReport.colorTied"
    :hide-elected="!votingRoundReport.colorElected"
    :disregard-blank="contest.disregardBlankVotes"
    :vote-counts="result.voterCounts"
  />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import type { ConferenceContest, PropType, Locale, Result, ConferenceVotingRoundReport } from "@/types";

export default defineComponent({
  name: "NormalSummary",
  props: {
    result: {
      type: Object as PropType<Result>,
      required: true,
    },
    votingRoundReport: {
      type: Object as PropType<ConferenceVotingRoundReport>,
      required: true,
    },
    contest: {
      type: Object as PropType<ConferenceContest>,
      required: true,
    },
    locale: {
      type: String as PropType<Locale>,
      default: "en",
    },
  },
  computed: {
    counts() {
      if (!this.resultData) return [];
      return this.resultData.optionCounts;
    },
    totalCount() {
      if (this.contest.disregardBlankVotes) {
        return Object.entries(this.counts)
          .filter(([reference, _count]) => reference.toString() !== "blank")
          .reduce((sum: number, [_reference, count]: any[]) => sum + count, 0);
      } else if (this.contest.consensusRequired && this.contest.countUnvoicedVotesAsBlank) {
        return this.contest.disregardWeight
          ? this.result.voterCounts.activeEligiblesOrVoted
          : this.result.voterCounts.activeEligiblesOrVotedWeight;
      } else {
        const excludedOptions = this.result.resultData?.exclusiveOptions.filter(reference => reference !== "blank")

        return Object.entries(this.result.resultData?.optionCounts)
          .filter(([reference, _count]) => !excludedOptions.includes(reference))
          .reduce((sum: number, [_reference, count]: any[]) => sum + count, 0);
      }
    },
    resultData() {
      return this.result.resultData;
    },
  },
});
</script>
